// src/pages/CallbackPage.jsx
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useCognitoSaml } from 'modules/auth/hooks/useCognitoSaml';

const CallbackPage = () => {
  const history = useHistory();
  const { handleCallback, loading, error } = useCognitoSaml();

  useEffect(() => {
    const processCallback = async () => {
      try {
        await handleCallback();
        // Check for stored return URL from IdP-initiated flow
        const storedReturnUrl = sessionStorage.getItem('saml_return_url');
        if (storedReturnUrl) {
          sessionStorage.removeItem('saml_return_url');
          history.push(storedReturnUrl);
        } else {
          // Default: redirect to dashboard
          history.push('/dashboard');
        }
      } catch (err) {
        console.error('Error procesando callback:', err);
        // Opcional: redirigir a login con error
        history.push('/login?error=auth_failed');
      }
    };

    processCallback();
  }, [handleCallback, history]);

  if (error) {
    return (
      <div className="text-center mt-5">
        <h3>Error de Autenticación</h3>
        <p>{error}</p>
        <button
          type="button"
          onClick={() => history.push('/login')}
          className="btn btn-primary"
        >
          Volver al Login
        </button>
      </div>
    );
  }

  return (
    <div className="text-center mt-5">
      <div className="spinner-border" role="status">
        <span className="sr-only">Procesando autenticación...</span>
      </div>
      <p className="mt-3">Iniciando sesión...</p>
    </div>
  );
};

export default CallbackPage;
